import { Component, OnInit, WritableSignal, signal, effect, computed, ViewChild } from '@angular/core';
import { TextareaModule } from 'primeng/textarea';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BaseFeedbackFormComponent } from '../shared/base-feedback-form.component';
import { givenFeedbackModel, givenFeedbackField, runsDataByUserRequest, currentFeedbackModel } from '../../../../../../shared/models/serviceModels/request/feedbackReq.model';

@Component({
  selector: 'app-others-form',
  standalone: true,
  imports: [ 
    FormsModule,
    CommonModule, 
    FontAwesomeModule,
    TextareaModule],
  templateUrl: './others-form.component.html',
  styleUrl: './others-form.component.scss'
})

export class OthersFormComponent extends BaseFeedbackFormComponent implements OnInit {
  
  protected givenFeedbackResponse: currentFeedbackModel = { feedbackFields: [], userId: "", userRoleId: 1, feedbackDate: new Date(), feedbackTypeId: 1};
  
  protected override getPredictionData?(): void {
    throw new Error('Method not implemented.');
  }

  isValid: WritableSignal<boolean> = signal(true);

  isFieldDisabled = computed(() => {
    return this.feedbackService.getFieldsStatus();
  })

  freeText: string = '';

  ngOnInit(): void {
    const singleData = this.feedbackService.getFormData()();

    this.feedbackFormData.set(singleData ? singleData : null);

    
    this.setDefaultValues();

  }

  setDefaultValues() {
   
    const defaultFeedbackData = this.feedbackService.getFeedbackBeforeSubmit();
    this.givenFeedbackResponse = defaultFeedbackData? defaultFeedbackData : this.givenFeedbackResponse;
    
    // let formData= this.feedbackFormData();
    // this.givenFeedbackResponse.predictionSourceTypeId = formData?.predictionSourceType?.feedbackFieldValues?.find(type => type.field?.toLowerCase().trim() === "prediction".toLowerCase())?.id ;
}
  

  validateFreeText(event: any) {
    let freeText = this.freeText;

    const sanitizedText = freeText.replace(/[^a-zA-Z0-9 .,!?'"()\-$\/#@%]/g, '');

    // Check if the sanitized text has at least 3 words
    const wordCount = sanitizedText.trim().split(/\s+/).length;
    this.checkIfAllMandatoryFieldsAreFilled();

    if (wordCount >= 2) {
      this.storeFreeText(sanitizedText);
      
    }
  }

  storeFreeText(text: string){

          const formFieldsData = this.feedbackFormData();


          let formFeedbackField = formFieldsData?.feedbackFields?.feedbackFieldValues?.find(item => item.field?.toLowerCase() === "free_text".toLowerCase());
         
          let feedbackField: givenFeedbackField = {
            dataTypeId: formFeedbackField?.dataTypeId || 0,
            fieldId: formFeedbackField?.id,
            fieldName: formFeedbackField?.field || "",
            fieldDescription: formFeedbackField?.description || "",
            value: text
          };

          this.storeFeedbackField(feedbackField);
  }

  
  storeFeedbackField(givenFeedbackField:givenFeedbackField){

    
    let existingFieldIndex = this.givenFeedbackResponse.feedbackFields.findIndex(field => field.fieldName === givenFeedbackField.fieldName);

    if (existingFieldIndex !== -1) {
      this.givenFeedbackResponse.feedbackFields[existingFieldIndex] = givenFeedbackField;
    } else {
      this.givenFeedbackResponse.feedbackFields.push(givenFeedbackField);
    }

    this.feedbackService.setFeedbackValues(this.givenFeedbackResponse!);

  }

  
  checkIfAllMandatoryFieldsAreFilled(){
    
    let areMandatoryFieldsFilled = this.freeText.trim().split(/\s+/).length >=2;
   
    // if ( this.freeText.trim().split(/\s+/).length >=2) {
    //   areMandatoryFieldsFilled = true;
    // }
    this.isValid.set(areMandatoryFieldsFilled);
    
    this.feedbackService.setAreMandatoryFieldsLoaded(areMandatoryFieldsFilled);
  }

  onFreeTextEntered(){
    //validacion para cuando hace blur sin haber ingresado +2 palabas
    this.checkIfAllMandatoryFieldsAreFilled();
    //queda: popup confirmacion, chequear que se esté guardando bien
  }
}
